import React from 'react'

import { Button, Card, Col, Drawer, Upload, Form, Icon, Popover, Checkbox, notification, Row, Select, Input } from 'antd'
import _ from 'lodash'
import styles from './styles.less'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { hideLoader, showLoader } from '../../modules/actions'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let content = <p>This invoice is created when your student is enrolled in an institute through a channel partner.<br />
    Enter all the details received by your channel partner to create the invoice.</p>
@Form.create()

class InvoiceUpdateForm extends React.Component {
    state = {
        visible: true,
        generatedInvoice: {},
        hasConversionRate: false,
        invoiceStatus: null,
        invoiceStatuses: [
            'Generated', 'Submitted to Uni', 'Approved by Uni', 'Paid by Uni', 'Cleared'
        ]
    }

    loadInvoiceDetail = async () => {
        const { invoiceId } = this.props;
        const res = await Request.getInvoiceDetail(invoiceId);
        if (!res.error) {
            this.setState({ generatedInvoice: res.doc, hasConversionRate: res.doc.hasConversionRate });
            let emailTo = [];
            if (res.doc.universityDetails && res.doc.universityDetails.contactEmailOne) {
                emailTo.push(res.doc.universityDetails.contactEmailOne);
            }
            if (res.doc.universityDetails && res.doc.universityDetails.contactEmailTwo) {
                emailTo.push(res.doc.universityDetails.contactEmailTwo);
            }
            this.props.form.setFieldsValue({
                emailTo: emailTo.join(', '),
                invoiceId: invoiceId
            });
        }
    }
    getAllTaxes = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        let data = await Request.getTaxDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allTaxes: data.data });
    }

    componentWillMount() {
        this.loadInvoiceDetail();
        this.getAllTaxes();
    }

    updateInvoice = async () => {
        const { invoiceId } = this.props;
        const { generatedInvoice, hasConversionRate } = this.state;
        let x = await Request.updateInvoiceData({ invoiceId, hasConversionRate, invoices: generatedInvoice.invoices, invoiceStatus: generatedInvoice.invoiceStatus, invoiceReceivingDate: generatedInvoice.invoiceReceivingDate, cpTaxTypeId: this.state.taxTypeId ? this.state.taxTypeId : null });

        if (!x.error) {
            notification.success({
                message: 'Invoice updated successfully'
            });
            this.onClose();
        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    updateValue = (key, index, input) => {
        let generatedInvoice = this.state.generatedInvoice;
        generatedInvoice.invoices[index][key] = input.target.value;
        this.setState({ generatedInvoice: generatedInvoice });
    }

    selectInvoiceStatus = (e) => {
        let generatedInvoice = this.state.generatedInvoice;
        generatedInvoice.invoiceStatus = e.target.value;
        this.setState({ generatedInvoice: generatedInvoice, invoiceStatus: e.target.value });
    }

    selectInvoiceReceivingDate = (e) => {
        let generatedInvoice = this.state.generatedInvoice;
        generatedInvoice.invoiceReceivingDate = e.target.value;
        this.setState({ generatedInvoice: generatedInvoice });
    }

    handleChange = (v) => {
        if (v.fileList) {
            let generatedInvoice = this.state.generatedInvoice;
            generatedInvoice.paymentReceipt = v.fileList;
            this.setState({ generatedInvoice: generatedInvoice });
        }
    };

    onRemove = (v) => {
        console.log(v);
    };

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    render() {
        const { dispatch } = this.props
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props
        const { invoiceId } = this.props;
        const { generatedInvoice, invoiceStatuses, allTaxes, taxPaidBy, hasConversionRate } = this.state;
        let invoiceReceivingDate = generatedInvoice.invoiceReceivingDate ? moment(generatedInvoice.invoiceReceivingDate).format('YYYY-MM-DD') : null;
        let totalAmount = generatedInvoice.invoices && generatedInvoice.invoices.reduce(function (oldValue, invoice) { return (invoice.commissionTypeFrom == 'Percentage' ? (parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) : parseFloat(invoice.commissionFromCourse)) + oldValue; }, 0);
        let totalConvertions = 0;
        return (
            <Drawer
                title={
                    <div>
                        {'Invoice:- '} {generatedInvoice.invoiceNumber}<b>/</b>{moment(generatedInvoice.invoiceGeneratedDate).format(dateFormat)}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <Checkbox
                        checked={hasConversionRate}
                        onChange={(y) => {
                            this.setState({ hasConversionRate: y.target.checked })
                        }}
                    >Have Conversion Rate <Popover placement='bottomLeft' content={content}>?</Popover>
                    </Checkbox>
                    <div className='ant-table ant-table-small ant-table-bordered ant-table-scroll-position-left ant-table-layout-fixed'>
                        <div className='ant-table-content'>
                            <div className='ant-table-scroll'>
                                <table className='ant-table-fixed' style={{ width: '900px' }}>
                                    <thead className='ant-table-thead'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Student Name</th>
                                            <th className='ant-table-row-cell-break-word'>Intitute Id</th>
                                            <th className='ant-table-row-cell-break-word'>Invoice To</th>
                                            <th className='ant-table-row-cell-break-word'>Course Name</th>
                                            <th className='ant-table-row-cell-break-word'>Tution Fee</th>
                                            <th className='ant-table-row-cell-break-word'>Commission</th>
                                            <th className='ant-table-row-cell-break-word'>Total</th>
                                            <th className='ant-table-row-cell-break-word' hidden={!hasConversionRate}>Conversion Rate</th>
                                            <th className='ant-table-row-cell-break-word' hidden={!hasConversionRate}>{generatedInvoice.companySettingDetail ? 'Total In ' + generatedInvoice.companySettingDetail.companyCurrency : ''}</th>
                                        </tr>
                                    </thead>
                                    <tbody className='ant-table-tbody'>
                                        {
                                            generatedInvoice.invoices ?
                                                generatedInvoice.invoices.map((invoice, index) => {
                                                    totalConvertions += (parseFloat(invoice.commissionTotal) * parseFloat(invoice.conversionRate));
                                                    return (
                                                        <tr key={index}>
                                                            <td className='ant-table-row-cell-break-word'>{invoice.studentName}</td>
                                                            <td className='ant-table-row-cell-break-word'>{invoice.instituteStudentId}</td>
                                                            <td className='ant-table-row-cell-break-word'>{generatedInvoice.invoiceToName}</td>
                                                            <td className='ant-table-row-cell-break-word'>{invoice.courseName}</td>
                                                            <td className='ant-table-row-cell-break-word'>{invoice.currency} {invoice.tutionFee}</td>
                                                            <td className='ant-table-row-cell-break-word'>{invoice.commissionFromCourse}{invoice.commissionTypeFrom == 'Percentage' ? '%' : 'Flat'}</td>
                                                            <td className='ant-table-row-cell-break-word'>{invoice.currency} {invoice.commissionTotal}</td>
                                                            <td className='ant-table-row-cell-break-word' hidden={!hasConversionRate}><Input onChange={(e) => { this.updateValue('conversionRate', index, e) }} value={invoice.conversionRate} /></td>
                                                            <td className='ant-table-row-cell-break-word' hidden={!hasConversionRate}>{generatedInvoice.companySettingDetail ? generatedInvoice.companySettingDetail.companyCurrency : ''}&nbsp;{(parseFloat(invoice.commissionTotal) * parseFloat(invoice.conversionRate)).toFixed(2)}</td>
                                                        </tr>
                                                    )
                                                })
                                                : null
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Total:- </th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'>{totalAmount ? totalAmount.toFixed(2) : '0.00'}</th>
                                            <th className='ant-table-row-cell-break-word' hidden={!hasConversionRate}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={!hasConversionRate}>{generatedInvoice.companySettingDetail ? generatedInvoice.companySettingDetail.companyCurrency : ''}&nbsp;{totalConvertions ? totalConvertions.toFixed(2) : '0.00'}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <Row>
                        <br />
                        <Col span={24}>
                            <select name='taxPaidBy' style={{ 'maxWidth': '300px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => { this.setState({ taxPaidBy: e.target.value }) }}>
                                <option value="">Choose Tax Paid By</option>
                                <option value="Company">Company</option>
                                <option value="University">University</option>
                            </select>
                        </Col>
                        {
                            taxPaidBy ?
                                <Col span={24}>
                                    <Row>
                                        <Col span={8}>
                                            <select name='taxTypeId' style={{ 'maxWidth': '300px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => { this.setState({ taxTypeId: e.target.value }) }}>
                                                <option value="">Choose Tax</option>
                                                {
                                                    allTaxes && allTaxes.length ?
                                                        allTaxes.map((item, index) => {
                                                            return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                        })
                                                        : null
                                                }
                                            </select>
                                        </Col>
                                        <Col span={4}>
                                            <Button className='ant-btn-primary' onClick={(e) => { this.setState({ showTaxDetailsDrawar: true }) }} type='button'>+</Button>
                                        </Col>
                                    </Row>
                                </Col>
                                : null
                        }
                        <br />
                        <Input type='date' value={invoiceReceivingDate} style={{ maxWidth: '300px' }} className='form-control' onChange={(e) => { this.selectInvoiceReceivingDate(e) }} />
                        <br />
                        <select name='invoiceStatus' value={generatedInvoice.invoiceStatus} style={{ maxWidth: '300px' }} className='form-control' onChange={(e) => { this.selectInvoiceStatus(e) }}>
                            <option value="">Select Option</option>
                            {
                                invoiceStatuses && invoiceStatuses.length ?
                                    invoiceStatuses.map((item, index) => {
                                        return (<option value={item} key={index}>{item}</option>)
                                    })
                                    : null
                            }
                        </select>
                        <br />
                        {
                            this.state.invoiceStatus === "Paid by Uni" || this.state.invoiceStatus === "Cleared" ?
                                <Upload
                                    style={{ marginBottom: 30 }}
                                    label={'Upload Payment Receipt'}
                                    name={'file'}
                                    action={`${LAPI_URL}/filesUploader`}
                                    onChange={this.handleChange}
                                    onRemove={this.onRemove}>
                                    <Button>
                                        <Icon type="upload" /> Payment Receipt
                                    </Button>
                                </Upload>
                                // <div className="gutter-example">
                                //     <Row gutter={16} className={styles['margin-t-md']}>
                                //         <Col className="gutter-row" span={6}>
                                //             <div className="gutter-box">Upload Payment Receipt</div>
                                //         </Col>
                                //         <Col className="gutter-row" span={18}>
                                //             <div className="gutter-box">

                                //             </div>
                                //         </Col>
                                //     </Row>
                                // </div>

                                : null
                        }
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="button"
                                style={{ marginBottom: 10, marginTop: 10 }}
                                onClick={() => { this.updateInvoice() }}
                                loading={this.props.loading}>
                                submit
                            </Button>
                        </Col>
                        <Col span={8} />
                    </Row>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InvoiceUpdateForm)